export default __webpack_public_path__ + "static/media/2.aec381cc.png";